const getEnv = () => {
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  } else {
    const hostname = window.location.hostname;
    return hostname.includes('localhost')
      ? 'local'
      : hostname.includes('dev')
        ? 'dev'
        : hostname.includes('qa')
          ? 'uat'
          : 'prod';
  }
};

const OKTA_LOGIN_URL =
  getEnv() === 'local'
    ? 'https://home.student-dev.monash/sso/authorization_code/login'
    : `${window.location.origin}/sso/authorization_code/login`;
const CALLBACK_PATH = '/authorization_code/callback';
const TOKEN_API =
  getEnv() === 'local'
    ? 'https://home.student-dev.monash/sso/authorization_code/firebase_custom_token'
    : `${window.location.origin}/sso/authorization_code/firebase_custom_token`;
const FIREBASE_DEV_CONFIG = {
  apiKey: 'AIzaSyCptfVWf5dHgWbLp_BCfjs5RhXtvBabRjc',
  authDomain: 'monash-portal-dev.firebaseapp.com',
  databaseURL: 'https://monash-portal-dev.firebaseio.com',
  projectId: 'monash-portal-dev',
  storageBucket: 'monash-portal-dev.appspot.com',
  messagingSenderId: '462013370613',
  appId: '1:462013370613:web:5a63c09edf70a3291a75bc',
  measurementId: 'G-RR4Q3HM06V',
};
const FIREBASE_UAT_CONFIG = {
  apiKey: 'AIzaSyAi6lQIcsUuxRuCFVF91f6l8fBpqqTTPaQ',
  authDomain: 'monash-portal-uat.firebaseapp.com',
  databaseURL: 'https://monash-portal-uat.firebaseio.com',
  projectId: 'monash-portal-uat',
  storageBucket: 'monash-portal-uat.appspot.com',
  messagingSenderId: '45422978824',
  appId: '1:45422978824:web:82b96dfc141060b2d42ebd',
  measurementId: 'G-LE1ZELWMCS',
};
const FIREBASE_PROD_CONFIG = {
  apiKey: 'AIzaSyAobRCA_WrVwH2oYf5FGhfS9OH75CeSaM4',
  authDomain: 'monash-portal-prod.firebaseapp.com',
  databaseURL: 'https://monash-portal-prod.firebaseio.com',
  projectId: 'monash-portal-prod',
  storageBucket: 'monash-portal-prod.appspot.com',
  messagingSenderId: '981200912861',
  appId: '1:981200912861:web:559fa9cdb03b7f7515f634',
  measurementId: 'G-VXXLR2QVB4',
};

const config = {
  local: {
    firebase: FIREBASE_DEV_CONFIG,
    oktaLoginUrl: OKTA_LOGIN_URL,
    callbackPath: CALLBACK_PATH,
    tokenApi: TOKEN_API,
  },
  dev: {
    firebase: FIREBASE_DEV_CONFIG,
    oktaLoginUrl: OKTA_LOGIN_URL,
    callbackPath: CALLBACK_PATH,
    tokenApi: TOKEN_API,
  },
  uat: {
    firebase: FIREBASE_UAT_CONFIG,
    oktaLoginUrl: OKTA_LOGIN_URL,
    callbackPath: CALLBACK_PATH,
    tokenApi: TOKEN_API,
  },
  prod: {
    firebase: FIREBASE_PROD_CONFIG,
    oktaLoginUrl: OKTA_LOGIN_URL,
    callbackPath: CALLBACK_PATH,
    tokenApi: TOKEN_API,
  },
};

export const env = getEnv();
const envConfig = config[env];
if (env !== 'prod') {
  console.log('env:', env);
  console.log('env config:', JSON.stringify(envConfig));
}
export default envConfig;
